import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Box, styled } from "@mui/material";

const MainContent = styled(Box)(({ theme }) => ({
    minHeight: "80vh",
    transition: "background-color 0.4s ease-in-out",
    backgroundColor: theme.palette.background.default,
}));

const Layout = ({ children, user, darkMode, setDarkMode }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header user={user} darkMode={darkMode} setDarkMode={setDarkMode} />
            <MainContent component="main">
                {children}
            </MainContent>
            <Footer />
        </Box>
    );
};

export default Layout;
